import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { Form, Button, Drawer, Input, message } from 'antd';
import * as aec_secret from 'src/utils/crypto';
import Doc from 'src/utils/Doc';
import  CommonInput  from 'src/display/components/CommonInput';

import { connect } from 'kts-platform-frame/redux'; 
import ReduxState from 'kts-platform-frame/redux/ReduxState';
import { create } from 'kts-scaffold-framework/utils/form'; 
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';

const FormItem = Form.Item;
/** Redux接口 */
interface IReduxStatePart {
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
}

/** 绑定全局数据 */
@create()
@connect((state: ReduxState): IReduxStatePart => ({
}))
export default class Head extends UIBasic<IProps, ModulesState> {
    constructor(props: IProps) {
        super(props, ModulesAction);
        this.state = {
            btnLoading: false
        };
    } 
    onSubmit = () => {
        this.props.form.validateFields(async (err, values) => {
            if(err)  {
                return;
            }
            this.setState({
                btnLoading: true
            });
            const param = {
                ...this.modulesState.emailData,
                ...values,
            }; 
            param.emailPwd = aec_secret.encrypt(values.emailPwd);
            let res: any;
            if(this.modulesState.emailData && this.modulesState.emailData.id){ // 修改  
                res = await ModulesAction.updateEmail(param);
            }else{ // 增加 
                res = await ModulesAction.addEmail(param);
            }
        
            if(res && !res.er){
                message.success('操作成功！');
                ModulesAction.setEmailSetVisible(false);
                ModulesAction.getEmailList(1);
            }
            this.setState({
                btnLoading: false
            });
            
        });
    }
    
    render() {
        const { getFieldDecorator } = this.props.form;
        const initData =  this.modulesState.emailData || {};
        return (
            <div>
                {
                    <Drawer
                        title={<span style={{color: 'rgba(0, 0, 0, 0.85)'}}>{initData.id ? '编辑' : '新增'}收票邮箱</span>} 
                        width={500}
                        onClose={() => ModulesAction.setEmailSetVisible(false)}
                        visible={this.modulesState.emailSetVisible}
                    >
                        <div>
                            <Form 
                                labelCol={{span: 8}}
                                wrapperCol={{span: 16 }}
                            >
                                <FormItem label="名称">
                                    {getFieldDecorator('emailName', {
                                        initialValue: initData.emailName,
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入名称'
                                            },
                                            { validator: Doc.Check.checkLength(100) }
                                        ]
                                    })(
                                        <CommonInput placeholder="请输入名称" maxLength={100} autoComplete='off'/>
                                    )}
                                </FormItem>
                                <FormItem label="邮箱地址">
                                    {getFieldDecorator('emailUrl', {
                                        initialValue: initData.emailUrl,
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入邮箱地址'
                                            },
                                            // { validator: Doc.Check.checkEmail }
                                        ]
                                    })(
                                        <Input autoComplete='off' placeholder="邮箱地址" />
                                    )}
                                </FormItem>
                                <FormItem label="密码/授权码" >
                                    {getFieldDecorator('emailPwd', {
                                        initialValue: initData.emailPwd,
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入登录密码'
                                            },
                                            { validator: Doc.Check.checkLength(50) }
                                        ]
                                    })(
                                        <Input.Password placeholder="支持1~50位字符" maxLength={50} autoComplete='new-password'/>
                                    )}
                                </FormItem>
                                <FormItem label="接收服务器地址">
                                    {getFieldDecorator('emailServiceUrl', {
                                        initialValue: initData.emailServiceUrl,
                                        rules: [
                                            {
                                                required: true,
                                                pattern: /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*$/,
                                                message: '请输入正确的服务器地址'
                                            }
                                        ]
                                    })(
                                        <CommonInput placeholder="服务器地址" maxLength={100} autoComplete='off' />
                                    )}
                                </FormItem> 
                                <FormItem> 
                                    <Button onClick={() => ModulesAction.setEmailSetVisible(false)}>取消</Button>
                                    <Button style={{marginLeft: '20px'}} type="primary" onClick={this.onSubmit} loading={this.state.btnLoading}>保存</Button>
                                </FormItem>
                            </Form> 
                            {/* <div className='footer'>
                                <Button onClick={() => ModulesAction.setEmailSetVisible(false)}>取消</Button>
                                <Button style={{marginLeft: '20px'}} type="primary" onClick={this.onSubmit} loading={this.state.btnLoading}>保存</Button>
                            </div> */}
                        </div>
                    </Drawer>
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/display/apps/InvoiceInput/UI.Email.Set.tsx